// extracted by mini-css-extract-plugin
module.exports = {"container":"swiperSlider-module--container--3V_BY","image":"swiperSlider-module--image--pUeEG"};